import { Component, Input, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { AbstractControl, FormArray, UntypedFormControl, UntypedFormGroup, ValidatorFn, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthenticationService } from '@app/_services';
import { CartService } from '@app/_services/cart.service';
import { QuotationCartService } from '@app/_services/quotation.service';
import * as _ from 'lodash';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { FormDataHelper, TranslateHelper } from '@app/_helpers';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { CurrencyFormatPipe } from '../../../shared/pipes/currency-format.pipe';
import { ProductGalleryComponent } from '../../../shared/components/product-gallery/product-gallery.component';
import { IconComponent } from '../../../shared/components/icon/icon.component';
import { FlexModule } from '@angular/flex-layout/flex';
import { EventCollectorDirective } from '../../../_directives/events-collector/events.collector';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { MultiDayPickerComponent } from './multi-day-picker/multi-day-picker.component';
import { SingleDateInlinePickerComponent } from './single-date-inlinePicker/single-date-inlinePicker.component';
import { DateRangeInlinePickerComponent } from './date-range-inlinePicker/date-range-picker.component';
import { NgIf, NgClass } from '@angular/common';
import { MatTabsModule } from '@angular/material/tabs';
import { ServiceDataEntry } from '@interfaces/professional-booking';

@Component({
    selector: 'app-booking-tabs',
    templateUrl: './booking-tabs.component.html',
    styleUrls: ['./booking-tabs.component.scss'],
    providers: [FormDataHelper, TranslateHelper],
    standalone: true,
    imports: [MatTabsModule, FormsModule, ReactiveFormsModule, NgIf, DateRangeInlinePickerComponent, SingleDateInlinePickerComponent, MultiDayPickerComponent, NgClass, ExtendedModule, EventCollectorDirective, FlexModule, IconComponent, ProductGalleryComponent, TranslateModule, CurrencyFormatPipe]
})
export class BookingTabsComponent implements OnInit {
    isQuotable: boolean;
    addToCartHidden: boolean;
    userDetails: any;
    constructor(
        private authService: AuthenticationService,
        private cart: CartService,
        private quotationCart: QuotationCartService,
        private toastr: ToastrService,
        private router: Router,
        private modalService: BsModalService,
        private formDataHelper: FormDataHelper,
        public translate: TranslateService,
        public translateHelper: TranslateHelper
    ) {
        this.selected = {
            startDate: moment(),
            endDate: moment(),
        };
    }

    @Input() withSidebar = false;
    @Input() tab = 'date';
    @Input() product: any;
    @Input() disabledDates: string[];
    @Input() timeslots: any;
    @Input() form: UntypedFormGroup;
    @Input() serviceData: any[];


 
    selected;
    addingToCart = false;


    dateType: "date_range" | "single_date" | "multi_date";
    timeType: "no_time" | "time_slots" | "time_range";

    _ = _;
    bsModalRef: BsModalRef;
    @ViewChild('modal', { read: TemplateRef }) template: TemplateRef<any>;

    //check if item is a quotation or quotable and can be added to cart
    checkIfQuotation() {
        if (this.product?.isOnlyQuotation) {
            this.isQuotable = true;
            this.addToCartHidden = true;
            let amount = (this.product.minQuotationAmount > 0) ? this.product.minQuotationAmount : 1;
            this.amount.setValue(amount);
        }
        else if (
            this.product.minQuotationAmount >= 1
        ) {
            this.isQuotable = true;
            this.addToCartHidden = false;
        }
    }


    ngOnInit(): void {
        this.checkIfQuotation();
        this.timeType = this.product.timeType;
        this.dateType = this.product.dateType;
        this.userDetails = this.authService.currentUserValue;
    }


    setQuantity(num) {
        num = parseInt(num);
        if (num < 1 || !_.isInteger(num)) {
            /// Do not let quantity drop below one
            this.form.controls['amount'].setValue(1);
        } else
            this.form.controls['amount'].setValue(num);
    }

    resetForm() {
        this.form.get('timeslots')?.setValue([]);
        this.form.controls.dates?.setValue([]);
        this.form.get("timeRange").reset()
        this.form.reset();
        this.form.get('amount').setValue(1);
        this.selected = null;
    }

    get amount() {
        return this.form.get('amount') as UntypedFormControl;
    }

    validateBooking() {
        this.serviceData = [];

        if (this.product.dateType == 'date_range') return this.validateDateRange();

        else if (this.dateType == 'single_date') return this.validateSingleDate();

        else if (this.dateType == 'multi_date') return this.validateMulti();

        else return true;

    }

    validateDateRange() {
        if (!this.form.get('dateRange').value?.start || !this.form.get('dateRange').value?.end) {
            this.toastr.error(this.translate.instant('booking_pick_date'));
            this.addingToCart = false;
            return false;
        }

        if (this.timeType == "time_range" && (!this.form.get('timeRange').value?.start || !this.form.get('timeRange').value?.end)) {
            this.toastr.error(this.translate.instant('booking_pick_time_range'));
            this.addingToCart = false;
            return false;
        }

        this.serviceData = [
            {
                amount: 1,
                date: this.formDate(this.form.get('dateRange').value?.start),
                endDate: this.formDate(this.form.get('dateRange').value?.end),
                ...(this.timeType == "time_range") && {
                    times: [
                        {
                            start: this.form.get('timeRange').value?.start,
                            end: this.form.get('timeRange').value?.end
                        }
                    ]
                },
            },
        ];

        return true;
    }

    validateSingleDate() {
        if (!this.form.get('date').value && !this.form.get('timeslots')?.value?.length) {
            this.toastr.error(this.translate.instant('booking_pick_date'));
            this.addingToCart = false;
            return false;
        }
        let date = this.formDate(this.form.get('date').value);
        if (this.timeType == 'time_slots') {
            if (this.form.get('timeslots').value?.length) {
                let slots = [];
                this.form.get('timeslots').value.forEach(slot => {
                    slots.push({
                        slotId: slot.slotId,
                        range: {
                            start: slot.range?.start,
                            end: slot.range?.end
                        },
                        amount: slot.control?.value
                    })
                });
                this.serviceData = [{
                    date: date,
                    amount: 1,
                    times: slots
                }];
                return true;
            } else {
                this.toastr.error(this.translate.instant('booking_pick_time'));
                this.addingToCart = false;
                return false;
            }

        } else if (this.timeType == "time_range") {
            if (this.form.get('timeRange').value?.start && this.form.get('timeRange').value?.end) {
                let start = new Date(this.form.get('timeRange').value?.start);
                let end = new Date(this.form.get('timeRange').value?.end)

                this.serviceData = [{
                    date: date,
                    amount: 1,
                    times: [
                        {
                            start: new Date(date.getFullYear(), date.getMonth(), date.getDate(), start.getHours(), start.getMinutes(), 0, 0),
                            end: new Date(date.getFullYear(), date.getMonth(), date.getDate(), end.getHours(), end.getMinutes(), 0, 0)
                        }
                    ]
                }]

                return true;
            } else {
                this.toastr.error(this.translate.instant('booking_pick_time'));
                this.addingToCart = false;
                return false;
            }
        } else {
            this.serviceData = [
                {
                    date: date,
                    amount: 1
                },
            ];
            return true;
        }
    }

    validateMulti() {
        if (_.isEmpty(this.form.get('dates').value)) {
            this.toastr.error(this.translate.instant('booking_pick_date'));
            this.addingToCart = false;
            return false;
        }

        if (this.timeType == "time_range" && (!this.form.get('timeRange').value?.start || !this.form.get('timeRange').value?.end)) {
            this.toastr.error(this.translate.instant('booking_pick_time_range'));
            this.addingToCart = false;
            return false;
        }

        let dates: any[] = this.form.get('dates').value;
        dates.forEach((date:Date) => {
            let start = new Date(this.form.get('timeRange').value?.start);
            let end = new Date(this.form.get('timeRange').value?.end)
            this.serviceData.push({
                date: this.formDate(date),
                ...(this.timeType == "time_range") && {
                    times: [
                        {
                            start: new Date(date.getFullYear(), date.getMonth(), date.getDate(), start.getHours(), start.getMinutes(), 0, 0),
                            end: new Date(date.getFullYear(), date.getMonth(), date.getDate(), end.getHours(), end.getMinutes(), 0, 0)
                        }
                    ]
                },
            });
        });
        return true;

        /* dates.forEach((date:Date) => {
            let start = new Date(this.form.get('timeRange').value?.start);
            let end = new Date(this.form.get('timeRange').value?.end)
            this.serviceData.push({
                date: this.formDate(date),
                ...(this.timeType == "time_range") && {
                    times: [
                        {
                            start: new Date(date.getFullYear(), date.getMonth(), date.getDate(), start.getHours(), start.getMinutes(), 0, 0),
                            end: new Date(date.getFullYear(), date.getMonth(), date.getDate(), end.getHours(), end.getMinutes(), 0, 0)
                        }
                    ]
                },
            });
        }); */
    }

    /** The validated selection as `serviceData`, or null when invalid (the reason is shown as a toast). */
    getSelection(): ServiceDataEntry[] | null {
        return this.validateBooking() ? this.serviceData : null;
    }

    formDate(input) {
        let date = new Date(input);
        date.setHours(date.getHours() + 3);
        return date;
    }


    addToCart(): void {
        if (this.addingToCart) return;

        this.addingToCart = true;

        if (this.validateBooking())
            if (this.product && this.form?.value?.amount > 0) {
                this.addingToCart = true;
                let cartItem: any = {
                    productId: this.product._id,
                    amount: this.form?.value?.amount,
                    serviceData: this.serviceData,
                    options: this.form.getRawValue().options
                };

                if (cartItem.options?.length > 0) {
                    let optionsFiltered = [];
                    _.forEach(cartItem.options, (option) => {
                        if (option.date != null) {
                            optionsFiltered.push({
                                optionId: option.optionId, value: {
                                    date: option.date,
                                    time: option.time
                                }
                            });
                        }
                        if (option.valueId != null || option.value != null) {
                            optionsFiltered.push(option);
                        }
                    });
                    cartItem.options = optionsFiltered;
                }

                if (!cartItem.options) delete cartItem.options;

                let optionFiles = this.form.getRawValue().optionFiles;
                if (optionFiles) {
                    cartItem['optionFiles'] = {};
                    _.forEach(optionFiles, (optionFile, key) => {
                        _.assign(cartItem['optionFiles'], optionFile);
                    });
                }
                let formData = this.formDataHelper.ToFormData(cartItem);
                this.cart.addItem(formData, this.product).subscribe(
                    (response) => {
                        if (response)
                            this.toastr.success(this.translate.instant('service_added_to_cart', {
                                name: this.translateHelper.localize(this.product.name)
                            }));
                        this.addingToCart = false;

                    }, (error) => {
                        this.toastr.error(this.translate.instant('error_adding_to_cart'));
                        this.addingToCart = false;
                    });
            }

    }

    addQuotation(): void {
        if (this.validateBooking()) {
            if (this.form?.value?.amount < this.product?.minQuotationAmount) {
                this.toastr.error(`Quantity Must be at least ${this.product?.minQuotationAmount}`);
                return;
            }

            if (this.form?.value?.amount <= 0) {
                this.toastr.error("Quantity Must be at least 1");
                return;
            }

            if (!this.userDetails) {
                this.router.navigate(['/login'], {
                    queryParams: {
                        returnUrl: this.router.routerState.snapshot.url,
                    },
                });
                return;
            }
            this.bsModalRef = this.modalService.show(this.template, {
                class: 'modal-lg'
            });
        }
    }


    public getColor(valid): string {
        return valid ? 'green' : 'red';
    }

    scrollTopOfTaps() {
        let el = document.getElementById('bDetails');
        el.scrollIntoView({ behavior: 'smooth' });
    }

    requestQuotation() {
        if (this.addingToCart) return;

        this.addingToCart = true;

        let cartItem: any = {
            productId: this.product._id,
            amount: this.form?.value?.amount,
            serviceData: this.serviceData,
            options: this.form.getRawValue().options
        };

        if (cartItem.options?.length > 0) {
            let optionsFiltered = [];
            _.forEach(cartItem.options, (option) => {
                if (option.date != null) {
                    optionsFiltered.push({
                        optionId: option.optionId, value: {
                            date: option.date,
                            time: option.time
                        }
                    });
                }
                if (option.valueId != null || option.value != null) {
                    optionsFiltered.push(option);
                }
            });

            cartItem.options = optionsFiltered;

        }

        let optionFiles = this.form.getRawValue().optionFiles;
        if (optionFiles) {
            cartItem['optionFiles'] = {};
            _.forEach(optionFiles, (optionFile, key) => {
                _.assign(cartItem['optionFiles'], optionFile);
            });
        }
        let formData = this.formDataHelper.ToFormData(cartItem);

        this.quotationCart.addSubmit(formData).subscribe(response => {
            if (response.code == 400) {
                this.toastr.error(response.msg);
                this.addingToCart = false;
                return;
            }
            this.bsModalRef.hide();
            this.toastr.success(response.msg);
            this.addingToCart = false;
        });

    }

    addToList() {
        if (this.addingToCart) return;

        this.addingToCart = true;

        let cartItem: any = {
            productId: this.product._id,
            amount: this.amount.value,
            options: this.form.getRawValue().options,
            serviceData: this.serviceData,
            suggestedPrice: this.form.value.suggestedPrice,
        };


        if (cartItem.options?.length > 0) {
            let optionsFiltered = [];
            _.forEach(cartItem.options, (option) => {
                if (option.date != null) {
                    optionsFiltered.push({
                        optionId: option.optionId, value: {
                            date: option.date,
                            time: option.time
                        }
                    });
                }
                if (option.valueId != null || option.value != null) {
                    optionsFiltered.push(option);
                }
            });

            cartItem.options = optionsFiltered;

        }


        let optionFiles = this.form.getRawValue().optionFiles;
        if (optionFiles) {
            cartItem['optionFiles'] = {};
            _.forEach(optionFiles, (optionFile, key) => {
                _.assign(cartItem['optionFiles'], optionFile);
            });
        }
        let formData = this.formDataHelper.ToFormData(cartItem);
        this.quotationCart.addItem(formData).subscribe((response: any) => {
            if (response) {
                this.toastr.success(this.translate.instant('item_added_to_quotation', { name: this.translateHelper.localize(this.product.name) }));
                this.addingToCart = false;
            }
        }, error => {
            this.toastr.error(this.translate.instant('error_adding_to_quotation'));
            this.addingToCart = false;
        })
    }
}
